import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';
import {
  SearchEntityGroupMasterRequest,
  DetailEntityGroupMasterRequest,
  UpdateEntityGroupMasterRequest,
  DeleteEntityGroupMasterRequest,
  DetailEntityGroupMasterResponse,
  SearchEntityGroupMasterRecord,
  SearchEntityGroupMasterResponse,
} from 'api-types/src/types/entity-group-master';

type AccountGrMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: SearchEntityGroupMasterRecord[];
  filterSearchData: SearchEntityGroupMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  accountGrDetail: DetailEntityGroupMasterResponse | {};
  success: boolean;
};

const initialState: AccountGrMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  accountGrDetail: {},
  success: false,
};

export const accountGrMasterSlice = createSlice({
  name: 'accountGrMaster',
  initialState,
  reducers: {
    filterAccountGr: (state, action: { payload: SearchEntityGroupMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterAccountGrSuccess: (state, action: { payload: SearchEntityGroupMasterResponse }) => {
      state.loading = false;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterAccountGrFailure: (state) => {
      state.loading = false;
    },
    filterAccountGrDrop: (state, action: { payload: SearchEntityGroupMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterAccountGrDropSuccess: (state, action: { payload: SearchEntityGroupMasterResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.success = false;
    },
    getDetailAccountGr: (state, action: { payload: DetailEntityGroupMasterRequest }) => {
      state.loading = true;
    },
    getDetailAccountGrSuccess: (state, action: { payload: DetailEntityGroupMasterResponse }) => {
      state.loading = false;
      state.accountGrDetail = action.payload;
    },
    getDetailAccountGrFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    registerAccountGr: (state, action: { payload: UpdateEntityGroupMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerAccountGrSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerAccountGrFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateAccountGr: (state, action: { payload: UpdateEntityGroupMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    updateAccountGrSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateAccountGrFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteAccountGr: (state, action: { payload: DeleteEntityGroupMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    deleteAccountGrSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteAccountGrFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataAccountGr: (state) => {
      state.accountGrDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterAccountGr,
  filterAccountGrSuccess,
  filterAccountGrFailure,
  filterAccountGrDrop,
  filterAccountGrDropSuccess,
  setLoadingExportExcel,
  getDetailAccountGr,
  getDetailAccountGrSuccess,
  getDetailAccountGrFailure,
  registerAccountGr,
  registerAccountGrSuccess,
  registerAccountGrFailure,
  updateAccountGr,
  updateAccountGrSuccess,
  updateAccountGrFailure,
  deleteAccountGr,
  deleteAccountGrSuccess,
  deleteAccountGrFailure,
  cleanDataAccountGr,
  cleanData,
} = accountGrMasterSlice.actions;

export default accountGrMasterSlice.reducer;
